export const IpVersionOptions = {
  IPV4: "IPv4",
  IPV6: "IPv6",
}
